<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text">
      {{ title }}
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'WorkTitleCard',

  props: {
    title: String
  }
}
</script>

<style></style>
